/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function AddUserIcon({ size = 'xsmall', ...rest }) {
  return (
    <svg
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      width={sizes[size]}
      height={sizes[size]}
      viewBox="0 0 20 20"
      {...rest}
    >
      <defs>
        <path
          id="path-1"
          d="M12.5 12.5a.5.5 0 111 0v6a.5.5 0 11-1 0v-6zM16 15a.5.5 0 110 1h-6a.5.5 0 110-1h6zM6.5 9a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-3.936 3.255l.022-.037c.01-.017.01-.017.13-.135l.12-.064c1.993-.96 5.47-.934 7.39.035a.5.5 0 01-.451.892c-1.611-.813-4.675-.85-6.398-.072l-.27.546a803.32 803.32 0 01-1.768 3.526l-.392.779a.5.5 0 11-.894-.45 2325.141 2325.141 0 002.158-4.3c.124-.248.216-.434.274-.553l.042-.085a.54.54 0 01.037-.082z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(2 1)">
          <mask id="mask-2" fill="#fff">
            <use xlinkHref="#path-1"></use>
          </mask>
          <use fill="currentColor" fillRule="nonzero" xlinkHref="#path-1"></use>
          <g fill="#0073E6" mask="url(#mask-2)">
            <path d="M0 0H20V20H0z" transform="translate(-2 -1)"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
